import styled from 'styled-components';

export const Header = styled.div`
  padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const GoalName = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
`;

export const Interactions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(4)}`};
  border-top: ${({ theme }) => `1px solid ${theme.palette.grey[400]}`};
`;
